import { modifier } from 'ember-modifier';
export default modifier<Element, [(inserted: Element) => void, (destroying: Element) => void]>(
  (element, [inserted, destroying]) => {
    inserted(element);
    return () => {
      if (destroying) {
        destroying(element);
      }
    };
  },
);
